module.exports = __webpack_public_path__ + "static/media/zhiya.bd30ef32.png";